import datetimeFormats from "@core/i18n/datetimeFormats";
export default () => ({
	fallbackLocale: "de",
	datetimeFormats: {
		"de": datetimeFormats,
		"en": {
			dateShort: {
				year: "numeric",
				month: "short",
				day: "numeric"
			},
			dateTime: {
				year: "numeric",
				month: "short",
				day: "numeric",
				weekday: "short",
				hour: "numeric",
				minute: "numeric"
			}
		}
	}
});
